module.exports = __webpack_public_path__ + "img/156.d4676a1d.png";